import { FC } from 'react'
import cn from 'classnames'
import styles from 'components/atoms/Announcement/Announcement.styl'
import { useFlexClassNames, useThemeClassNames } from 'hooks/useClassNames'
import { Theme } from 'interfaces/component'

const Announcement: FC<{ theme?: Theme }> = ({ theme = 'midnight', children }) => {
  const themeClassNames = useThemeClassNames(theme)
  const flexClassNames = useFlexClassNames({
    verticallyCenter: true,
    horizontallyCenter: true,
    horizontal: true,
    padding: 'defaultSize',
  })
  const className = cn(styles.announcement, flexClassNames, themeClassNames)

  return (
    <div className={ className }>
      { children }
    </div>
  )
}

export default Announcement
